import { getPortalHttp } from '@/utils/http/portalHttp';
import type { NewRouterGroupApi } from './type';
export const newRouterGroupApi = {
  getNewRouterGroup() {
    return getPortalHttp().get<NewRouterGroupApi.Result>('new-router-group/web');
  },
};